export default "__VITE_ASSET__B1ooxy$K__"